module.exports = __webpack_public_path__ + "static/media/discover.464cbb77.svg";